import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";

export const GenericErrorDisplay = () => {
  const navigate = useNavigate();

  return (
    <div className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-destructive">An error occurred</p>
        <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance sm:text-7xl">
          Oops! Our Server is Having a Bad Day.
        </h1>
        <p className="mt-6 text-lg font-medium text-pretty sm:text-xl/8">
          Please refresh the page to try again.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button onClick={() => navigate(-1)}>Go back</Button>
          <Button variant="outline" disabled>
            Contact support <span aria-hidden="true">&rarr;</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export const UserProfileErrorDisplay = () => {
  return (
    <div className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-destructive">An error occurred</p>
        <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance sm:text-7xl">
          Failed to retrieve profile information.
        </h1>
        <p className="mt-6 text-lg font-medium text-pretty sm:text-xl/8">
          Please refresh the page to try again.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button variant="outline" disabled>
            Contact support <span aria-hidden="true">&rarr;</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export const AccessDeniedDisplay = () => {
  return (
    <div className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-amber-600">Access Required</p>
        <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance sm:text-7xl">
          Welcome to Photon Flow
        </h1>
        <p className="mt-6 text-lg font-medium text-pretty sm:text-xl/8">
          You're successfully authenticated, but you need administrator approval to access Photon
          Flow.
        </p>
        <p className="mt-4 text-base text-muted-foreground">
          Please contact a system administrator from the Silicon Photonics team to request access to
          this application.
        </p>
      </div>
    </div>
  );
};
